import { Directive, ElementRef, EventEmitter, HostListener, ComponentFactoryResolver, Input, Output, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AxisFile } from './axisFile';
import { FileuploadAlertComponent } from './fileupload-alert.component';

@Directive({
  selector: '[axis-drag-highlight]',
  exportAs: 'axis-drag-highlight'
})
export class DocumentDragOverlayDirective {
  public isFile = false;

  @Input() documentFlag = false;
  @Input() imagePreview = false;
  @Input() restrictFiles = '';
  @Input() isMulti = true;
  @Input() isAppendable = true;
  @Input() invalidFileMsg = 'File type is not supported.';
  @Input() maxFileSize: number;

  @Output() listChange: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  discardedFilesListEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() largerFilesEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input() public uploadFileList: Array<AxisFile> = new Array<AxisFile>();
  public invalidFilesList: Array<AxisFile> = new Array<AxisFile>();
  public largerFilesList: Array<AxisFile> = new Array<AxisFile>();

  constructor(private _eref: ElementRef,
    private resolver: ComponentFactoryResolver,
    private viewRef: ViewContainerRef,
    private sanitizer: DomSanitizer) {
    if (!this.uploadFileList) {
      this.uploadFileList = new Array<AxisFile>();
    }
  }
  @HostListener('dragenter', ['$event'])
  ondragenter(event) {
    if (
      event.dataTransfer.types[0] === 'Files' ||
      event.dataTransfer.types[1] === 'Files'
    ) {
      this.isFile = true;
      event.preventDefault();
      this._eref.nativeElement.classList.add('axis-drag-highlight');
    } else {
      this.isFile = false;
    }
  }
  @HostListener('dragend', ['$event'])
  ondragend(event) {
    if (this.isFile) {
      this._eref.nativeElement.classList.remove('axis-drag-highlight');
      event.preventDefault();
    }
  }
  @HostListener('drop', ['$event'])
  ondrop(event) {
    if (this.isFile) {
      event.preventDefault();
      this.onUploadDrop(event);
      this._eref.nativeElement.classList.remove('axis-drag-highlight');
    }
  }

  @HostListener('dragover', ['$event'])
  ondragover(event) {
    if (this.isFile) {
      event.preventDefault();
    }
  }

  @HostListener('dragleave', ['$event'])
  ondragleave(event) {
    if (this.isFile) {
      event.preventDefault();
      if (event.target.classList.contains('axis-drag-highlight')) {
        this._eref.nativeElement.classList.remove('axis-drag-highlight');
      }
    }
  }

  getImageThumbnail(data) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      const sanitizer = this.sanitizer;
      reader.onload = function (e) {
        data.src = sanitizer.bypassSecurityTrustResourceUrl(reader.result.toString());
        resolve(data.src);
      };
      reader.readAsDataURL(data.file);
    });
  }

  loadthumbnails() {
    let af: AxisFile;
    const promises: Array<any> = new Array<any>();

    for (let i = 0; i < this.uploadFileList.length; i++) {
      af = this.uploadFileList[i];
      promises.push(this.getImageThumbnail(af));
    }

    Promise.all(promises).then(() => {
      this['listChange'].emit(this.uploadFileList);
    });
  }

  isFileAlredySelected(checkFile: AxisFile) {
    let af: AxisFile;
    for (let i = 0; i < this.uploadFileList.length; i++) {
      af = this.uploadFileList[i];
      if (checkFile.file.name === af.file.name) {
        return true;
      }
    }
    return false;
  }

  delete(file: AxisFile) {
    let af: AxisFile;
    for (let i = 0; i < this.uploadFileList.length; i++) {
      af = this.uploadFileList[i];
      if (file.file.name === af.file.name) {
        this.uploadFileList.splice(i, 1);
        i--;
      }
    }

    this.listChange.emit(this.uploadFileList);
  }

  onUploadDrop(event) {
    if (
      event.dataTransfer.types[0] === 'Files' ||
      event.dataTransfer.types[1] === 'Files'
    ) {
      event.preventDefault();
    }
    if (!this.isAppendable || !this.isMulti) {
      this.uploadFileList = new Array<AxisFile>();
    }
    let af: AxisFile;
    let isValidFormatFile: any = 0;
    this.invalidFilesList = [];
    this.largerFilesList = [];
    for (let i = 0; i < event.dataTransfer.files.length; i++) {
      af = new AxisFile();
      af.file = event.dataTransfer.files[i];
      let fileType: any = af.file.name.split('.');
      af.id = i;
      fileType = fileType[fileType.length - 1];
      af.icon = this.setIcon(fileType, af);
      isValidFormatFile =
        this.restrictFiles &&
        this.restrictFiles.toLowerCase().indexOf(fileType.toLowerCase());
      if (
        !this.isFileAlredySelected(af) &&
        isValidFormatFile >= 0 &&
        ((this.maxFileSize && af.file.size <= this.maxFileSize) ||
          !this.maxFileSize)
      ) {
        this.uploadFileList.push(af);
      } else if (isValidFormatFile === -1) {
        this.invalidFilesList.push(af);
        this.showAlert();
      } else if (this.maxFileSize && af.file.size > this.maxFileSize) {
        this.largerFilesList.push(af);
      }
      if (!this.isMulti) {
        break;
      }
    }
    for (let i = 0; i < this.uploadFileList.length; i++) {
      this.uploadFileList[i].id = i;
    }
    if (this.imagePreview) {
      this.loadthumbnails();
    } else {
      this.listChange.emit(this.uploadFileList);
    }
    if (this.invalidFilesList && this.invalidFilesList.length > 0) {
      this.discardedFilesListEmitter.emit(this.invalidFilesList);
    }
    if (this.largerFilesList && this.largerFilesList.length > 0) {
      this.largerFilesEmitter.emit(this.largerFilesList);
    }
  }

  setIcon(fileType, af): string {
    let icon: string;
    if (af.file.type.toLowerCase().indexOf('image') === -1) {
      if (fileType === 'docx') {
        icon = 'doc';
      } else if (fileType === 'pptx') {
        icon = 'ppt';
      } else if (fileType === 'msg') {
        icon = 'mail';
      } else if (fileType === 'xlsx') {
        icon = 'xls';
      } else {
        icon = fileType;
      }
    }
    return icon;
  }

  showAlert() {
    const factory = this.resolver.resolveComponentFactory(FileuploadAlertComponent);
    const componentRef = this.viewRef.createComponent(factory);
    this._eref.nativeElement.appendChild(
      componentRef.location.nativeElement
    );
    componentRef.instance.invalidFileMsg = this.invalidFileMsg;
  }
}
